export const buildConnectionsFromPassengerList = (passengerList = []) => {
  if (!Array.isArray(passengerList)) return [];

  const connections = new Map();

  // Require certain flight times to be present for the connection to be valid
  const hasRequiredTime = (direction, flight) => {
    if (!flight) return false;
    if (direction === "outbound") {
      return !!(flight.departureTime || flight.estimatedDepartureTime);
    }
    if (direction === "inbound") {
      return !!(flight.arrivalTime || flight.estimatedArrivalTime);
    }
    return false;
  };

  for (const passenger of passengerList) {
    // Process inbound connections
    for (const flight of passenger.inboundConnections || []) {
      if (!hasRequiredTime("inbound", flight)) continue;
      addPassengerToConnection(connections, "inbound", flight, passenger);
    }

    // Process outbound connections
    for (const flight of passenger.outboundConnections || []) {
      if (!hasRequiredTime("outbound", flight)) continue;
      addPassengerToConnection(connections, "outbound", flight, passenger);
    }
  }

  return Array.from(connections.values());
};

// Helper function to add a passenger to a connection
const addPassengerToConnection = (
  connections,
  direction,
  flight,
  passenger
) => {
  if (!flight?.flightNumber || !passenger?.id) return;

  const key = `${direction}|${flight.flightNumber}|${flight.departure}|${flight.destination}`;

  if (!connections.has(key)) {
    connections.set(key, {
      id: key,
      direction,
      flightNumber: flight.flightNumber,
      from: flight.departure,
      to: flight.destination,
      departureTime: flight.departureTime,
      estimatedDepartureTime: flight.estimatedDepartureTime,
      actualDepartureTime: flight.actualDepartureTime,
      departureTimeQualifier: flight.departureTimeQualifier,
      arrivalTime: flight.arrivalTime,
      estimatedArrivalTime: flight.estimatedArrivalTime,
      actualArrivalTime: flight.actualArrivalTime,
      arrivalTimeQualifier: flight.arrivalTimeQualifier,
      gate: flight.departureGate || flight.gate || flight.arrivalStand || null,
      passengers: [],
    });
  }

  // Extract only the passenger fields needed by PassengerModal
  const passengerData = {
    id: passenger.id,
    name: passenger.name,
    seat: passenger.seat,
    services: passenger.services,
    mealObject: passenger.mealObject,
    boarded: passenger.boarded,
    checkedIn: passenger.checkedIn,
    passengerType: passenger.passengerType,
    wheelchair: passenger.wheelchair,
    inboundConnections: passenger.inboundConnections,
    outboundConnections: passenger.outboundConnections,
    customerBookingReference: passenger.customerBookingReference,
    securityNumber: passenger.securityNumber,
    isStaff: passenger.isStaff,
  };

  connections.get(key).passengers.push(passengerData);
};

export default buildConnectionsFromPassengerList;
